<template>
  <div class="resources-calendar mobile-scroll">
    <table>
      <thead>
      <tr>
        <td>{{ $t('resources.resource') }}</td>
        <td v-for="date in weekdays">
          <span class="day">{{ date | localedDate }}</span>
          <span class="weekday">{{ date | localedDateWeekday }}</span>
        </td>
      </tr>
      </thead>
      <tbody>
      <tr v-for="resource in resources">
        <td>
          <span class="resource">
            {{ resource.name }}
            <b-tooltip :label="`${$t('documents.fields.maintainer')} ${resource.maintainer.initials}`"
                       type="is-light">
                  <b-icon icon="help-circle-outline"
                          size="is-small"
                          class="has-text-primary">
                  </b-icon>
                </b-tooltip>
          </span>
        </td>
        <td v-for="date in weekdays">
          <div class="reservation" v-for="reservation in reservations(date, resource.reservations)">
            <span class="time">
              {{ reservation.starts_at | timeFormat }} - {{ reservation.ends_at | timeFormat }}
            </span>
            <span class="author">
              <a @click="userDetail(reservation.employee.id)" class="has-text-white">
                {{ reservation.employee.initials }}
              </a>
            </span>
            <span class="remove"
                  v-if="(account.employee.id === reservation.employee.id)
                        || (account.employee.id === resource.maintainer.id)"
                  @click="remove(resource.id, reservation.id)">
              <b-icon icon="close"
                      size="is-small"
                      class="has-text-white">
              </b-icon>
            </span>
          </div>

          <button class="button is-small is-success"
                  v-if="!isDateExpired(date)"
                  @click="reserve(date, resource.id)">
            {{ $t('resources.reserve') }}
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import {isDayEqual, isDateExpired, userDetail} from '@/utils'
  import {mapState} from 'vuex'
  const day = 1000 * 60 * 60 * 24

  export default {
    props: {
      currentDate: {
        type: Date,
        required: false,
        default: new Date().setHours(0,0,0,0)
      },
      resources: {
        type: Array,
        required: true
      }
    },
    methods: {
      userDetail,
      reservations(date, reservations) {
        let result = []
        reservations.map((reservation) => {
          let reservationDate = new Date(reservation.starts_at)
          if(isDayEqual(date, reservationDate)) result.push(reservation)
        })
        return result
      },
      reserve(date, resourceId) {
        this.$emit('reserve', {date, resourceId})
      },
      remove(resourceId, reservationId) {
        this.$emit('remove-reservation', {resourceId, reservationId})
      },
      isDateExpired
    },
    computed: {
      ...mapState('Account', ['account']),
      weekdays() {
        return [
          new Date(this.currentDate.getTime()),
          new Date(this.currentDate.getTime() + day),
          new Date(this.currentDate.getTime() + 2 * day),
          new Date(this.currentDate.getTime() + 3 * day),
          new Date(this.currentDate.getTime() + 4 * day),
          new Date(this.currentDate.getTime() + 5 * day),
          new Date(this.currentDate.getTime() + 6 * day)
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/variables";
  .resources-calendar {
    table {
      width: 100%;

      td {
        border: 1px solid #d1d1d1;
        padding: 10px;
        width: 12.5%;

        .button {
          opacity: 0;
          margin: 0 auto;
          width: 100%;
        }

        &:hover .button {
          opacity: 1;
        }
      }

      thead td:first-child {
        vertical-align: middle;
      }
    }

    .day {
      display: block;
    }

    .weekday {
      display: block;
      font-size: 12px;
      color: #888;
    }

    .resource {
      display: block;
      font-size: 13px;
      margin-bottom: 10px;
    }

    .reservation {
      background: $primary-color;
      color: #fff;
      border-radius: 4px;
      padding: 4px 8px;
      margin-bottom: 5px;
      position: relative;

      .time {
        font-size: 10px;
        display: block;
      }

      .author {
        font-size: 12px;
        display: block;
      }

      .remove {
        position: absolute;
        top: 0;
        right: 4px;
        cursor: pointer;
        &:hover {
          opacity: .6;
        }
      }
    }
  }
</style>